// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../src/assets/fonts/AvenirRegular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "Avenir";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

body {
    font-family: "Avenir", sans-serif !important;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px 5px 10px;
    background: #fff;
    border-bottom: 2px solid #e1e1e3;
    font-family: "Avenir", sans-serif;
    margin-bottom: -5px;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 14px;
}

.logo {
    width: 150px;
    left: 0%;
    margin-left: -40px
}

.collapsed .logo {
    width: 50px;
}

.toggle {
    width: 18px;
    cursor: pointer;
    opacity: 0.7;
    margin-left: 75px;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 0px;
}

.group {
    display: flex;
    align-items: center;
    gap: 6px;
    background: transparent;
    padding: 0;
    border-radius: 6px;
    margin-right: 0;
}

.playing-btn {
    background: #ED6926;
    color: #fff;
    border: none;
    padding: 3px 10px;
    border-radius: 6px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    font-weight: normal;
}

.stop-btn {
    background: #4a4b57;
    color: #fff;
    border: none;
    padding: 3px 5px;
    border-radius: 6px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    font-weight: normal;
    margin: 2px 0px 2px 5px;
}

.date-filter {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #555;
    gap: 4px;
    font-weight: normal;
    cursor: pointer;
    font-family: Avenir;
}

.arrow {
    font-size: 20px !important;
    color: #ED6926;
    cursor: pointer;
}

.status {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
}

.live {
    color: #ED6926;
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    font-weight: 600;
    font-family: Avenir !important;
}

.offline {
    color: #4a4b57;
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    font-weight: 600;
    font-family: Avenir !important;
}

.count {
    font-size: 11px;
    padding: 1px 6px;
    border-radius: 4px;
    color: #fff;
    font-weight: 600;
    width: auto;
    height: auto;
    line-height: 16px;
    display: inline-block;
    text-align: center;
}

.orange {
    background: #ED6926;
}

.dark {
    background: #4a4b57;
}

.divider-line {
    width: 1px;
    height: 18px;
    background: #d9d9db;
    margin: 0 4px;
}

.dropdown {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #333;
    cursor: pointer;
}

.date-wrapper {
    position: relative;
}

.date-dropdown {
    /*position:absolute;*/
    position: fixed;
    top: 40px;
    right: 0;
    z-index: 9999;
    background: #fff;
    border-radius: 10px;
    padding: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    border: 1px solid #e5e5e5;
    animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-5px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.profile-container {
    position: relative;
    display: flex;
    align-items: center;
}

.profile-name {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #4a4b57;
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-family: Avenir !important;
}

.mobile-dropdown-menu {
    display: none;
    /* Hidden by default on laptop */
}

.phoneMenu {
    display: none;
}

.hideOnDesktop {
    display: none;
}

/* Phone view css */
@media (max-width: 768px) {
    .phoneMenu {
        display: block;
        color: #ED6926;
        z-index: 999 !important;
        cursor: pointer;
    }

    .hideOnDesktop {
        display: block;
    }

    .dropdown {
        font-size: 14px;
    }

    .header {
        padding: 10px 10px 8px 10px;
    }

    .toggle {
        display: none !important;
    }

    .mobile-hidden {
        display: none !important;
    }

    .logo {
        position: static;
        width: 170px;
        margin-left: 0px;
    }

    .mobile-dropdown-menu {
        display: block;
        position: absolute;
        top: 40px;
        right: 0;
        background: #fff;
        width: 250px;
        border: 1px solid #e1e1e3;
        border-radius: 8px;
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
        z-index: 9999;
        padding: 10px;
    }

    .mobile-menu-item {
        padding: 12px 10px;
        border-bottom: 1px solid #f5f5f5;
        font-size: 13px;
        color: #444;
    }

    .mobile-menu-item:last-child {
        border-bottom: none;
    }

    .small-text {
        font-size: 11px;
        color: #888;
    }

    .dark-text {
        color: #4a4b57;
    }

    .rotate {
        transform: rotate(180deg);
    }

    .mobile-date-picker-inline {
        margin-top: 10px;
        border: 1px solid #eee;
        border-radius: 4px;
        overflow: hidden;
    }
}

.profile-container {
    position: relative;
}

.desktop-dropdown-menu {
    position: absolute;
    top: 40px;
    right: 0;
    background: #222;
    border-radius: 6px;
    padding: 0px;
    min-width: 90px;
    z-index: 999;
}

.desktop-dropdown-menu .btn {
    width: 100%;
    text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/header.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,+DAAuE;AAC3E;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;IAChB,gCAAgC;IAChC,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,SAAS;IACT,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,yBAAyB;IAIzB,kCAAkC;AAHtC;;AAMA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI;QACI,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,gBAAgB;QAChB,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,yCAAyC;QACzC,aAAa;QACb,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,gCAAgC;QAChC,eAAe;QACf,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB","sourcesContent":["@font-face {\n    font-family: \"Avenir\";\n    src: url(\"../../src/assets/fonts/AvenirRegular.ttf\") format(\"truetype\");\n}\n\nbody {\n    font-family: \"Avenir\", sans-serif !important;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px 10px 5px 10px;\n    background: #fff;\n    border-bottom: 2px solid #e1e1e3;\n    font-family: \"Avenir\", sans-serif;\n    margin-bottom: -5px;\n}\n\n.header-left {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n}\n\n.logo {\n    width: 150px;\n    left: 0%;\n    margin-left: -40px\n}\n\n.collapsed .logo {\n    width: 50px;\n}\n\n.toggle {\n    width: 18px;\n    cursor: pointer;\n    opacity: 0.7;\n    margin-left: 75px;\n}\n\n.header-right {\n    display: flex;\n    align-items: center;\n    gap: 0px;\n}\n\n.group {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background: transparent;\n    padding: 0;\n    border-radius: 6px;\n    margin-right: 0;\n}\n\n.playing-btn {\n    background: #ED6926;\n    color: #fff;\n    border: none;\n    padding: 3px 10px;\n    border-radius: 6px;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    font-weight: normal;\n}\n\n.stop-btn {\n    background: #4a4b57;\n    color: #fff;\n    border: none;\n    padding: 3px 5px;\n    border-radius: 6px;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    font-weight: normal;\n    margin: 2px 0px 2px 5px;\n}\n\n.date-filter {\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    color: #555;\n    gap: 4px;\n    font-weight: normal;\n    cursor: pointer;\n    font-family: Avenir;\n}\n\n.arrow {\n    font-size: 20px !important;\n    color: #ED6926;\n    cursor: pointer;\n}\n\n.status {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 13px;\n}\n\n.live {\n    color: #ED6926;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 12px;\n    font-weight: 600;\n    font-family: Avenir !important;\n}\n\n.offline {\n    color: #4a4b57;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 12px;\n    font-weight: 600;\n    font-family: Avenir !important;\n}\n\n.count {\n    font-size: 11px;\n    padding: 1px 6px;\n    border-radius: 4px;\n    color: #fff;\n    font-weight: 600;\n    width: auto;\n    height: auto;\n    line-height: 16px;\n    display: inline-block;\n    text-align: center;\n}\n\n.orange {\n    background: #ED6926;\n}\n\n.dark {\n    background: #4a4b57;\n}\n\n.divider-line {\n    width: 1px;\n    height: 18px;\n    background: #d9d9db;\n    margin: 0 4px;\n}\n\n.dropdown {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 12px;\n    color: #333;\n    cursor: pointer;\n}\n\n.date-wrapper {\n    position: relative;\n}\n\n.date-dropdown {\n    /*position:absolute;*/\n    position: fixed;\n    top: 40px;\n    right: 0;\n    z-index: 9999;\n    background: #fff;\n    border-radius: 10px;\n    padding: 10px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n    border: 1px solid #e5e5e5;\n}\n\n.date-dropdown {\n    animation: fadeIn 0.2s ease-in-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-5px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.profile-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.profile-name {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    background: #4a4b57;\n    color: #fff;\n    font-size: 10px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-family: Avenir !important;\n}\n\n.mobile-dropdown-menu {\n    display: none;\n    /* Hidden by default on laptop */\n}\n\n.phoneMenu {\n    display: none;\n}\n\n.hideOnDesktop {\n    display: none;\n}\n\n/* Phone view css */\n@media (max-width: 768px) {\n    .phoneMenu {\n        display: block;\n        color: #ED6926;\n        z-index: 999 !important;\n        cursor: pointer;\n    }\n\n    .hideOnDesktop {\n        display: block;\n    }\n\n    .dropdown {\n        font-size: 14px;\n    }\n\n    .header {\n        padding: 10px 10px 8px 10px;\n    }\n\n    .toggle {\n        display: none !important;\n    }\n\n    .mobile-hidden {\n        display: none !important;\n    }\n\n    .logo {\n        position: static;\n        width: 170px;\n        margin-left: 0px;\n    }\n\n    .mobile-dropdown-menu {\n        display: block;\n        position: absolute;\n        top: 40px;\n        right: 0;\n        background: #fff;\n        width: 250px;\n        border: 1px solid #e1e1e3;\n        border-radius: 8px;\n        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n        z-index: 9999;\n        padding: 10px;\n    }\n\n    .mobile-menu-item {\n        padding: 12px 10px;\n        border-bottom: 1px solid #f5f5f5;\n        font-size: 13px;\n        color: #444;\n    }\n\n    .mobile-menu-item:last-child {\n        border-bottom: none;\n    }\n\n    .small-text {\n        font-size: 11px;\n        color: #888;\n    }\n\n    .dark-text {\n        color: #4a4b57;\n    }\n\n    .rotate {\n        transform: rotate(180deg);\n    }\n\n    .mobile-date-picker-inline {\n        margin-top: 10px;\n        border: 1px solid #eee;\n        border-radius: 4px;\n        overflow: hidden;\n    }\n}\n\n.profile-container {\n    position: relative;\n}\n\n.desktop-dropdown-menu {\n    position: absolute;\n    top: 40px;\n    right: 0;\n    background: #222;\n    border-radius: 6px;\n    padding: 0px;\n    min-width: 90px;\n    z-index: 999;\n}\n\n.desktop-dropdown-menu .btn {\n    width: 100%;\n    text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
